"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var core_1 = require("@theme-ui/core");
var theme_provider_1 = require("@theme-ui/theme-provider");
var react_1 = require("react");
var helpers_1 = require("./helpers");
var ThemeProvider = function (_a) {
    var children = _a.children, colors = _a.colors;
    var theme = (0, core_1.useThemeUI)().theme;
    var computedTheme = (0, react_1.useMemo)(function () {
        var computedColors = typeof colors === "function" ? colors(theme.rawColors) : colors;
        if (computedColors && "background" in computedColors) {
            computedColors.text = (0, helpers_1.getMostReadable)(computedColors.background).toHexString();
        }
        return (0, helpers_1.overrideThemeColors)(theme, computedColors);
    }, [colors, theme]);
    return ((0, core_1.jsx)(theme_provider_1.ThemeProvider, { theme: computedTheme }, children));
};
exports.default = (0, react_1.memo)(ThemeProvider);
